import {Component, EventEmitter, Input, OnInit, Output,} from "@angular/core";

@Component({
  selector: 'yo-date-range-box',
  templateUrl: './date-range-box.component.html',
  styleUrls: ['./date-range-box.component.scss']
})

export class DateRangeBoxComponent implements OnInit {
  now : Date = new Date();
  dateEnd : Date  = new Date();

  @Output() onValueChange = new EventEmitter;
  @Input() height: String = "auto";
  @Input() selectedDates: Date[] = [this.now, this.dateEnd];

  ngOnInit(): void {}

  onValueChanged = (dates):void => {
    let filterDatesLivraisons: Date[];
    if (dates.value[0]) {
      const startDate = dates.value[0];
      let endDate: any;
      if (dates.value[1])
        endDate =  dates.value[1];
      else
        endDate = dates.value[0];
      filterDatesLivraisons = [startDate, endDate]
    } else
      filterDatesLivraisons = undefined
    this.onValueChange.emit(filterDatesLivraisons);
  };

}
